import { render, staticRenderFns } from "./CatchupModal.vue?vue&type=template&id=a8724662&scoped=true&"
import script from "./CatchupModal.vue?vue&type=script&lang=js&"
export * from "./CatchupModal.vue?vue&type=script&lang=js&"
import style0 from "./CatchupModal.vue?vue&type=style&index=0&id=a8724662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8724662",
  null
  
)

export default component.exports